import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { CurrentStateService } from '../../../core/services/current-state.service';
import { MENU_OPTIONS } from '../../constants/left-menu-option';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'app/core/services/keycloak.service';
import { LocalStorageService } from '@shared/services/utilities/local-storage.service';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-nav-bar-left',
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './nav-bar-left.component.html',
  styleUrl: './nav-bar-left.component.scss'
})
export class NavBarLeftComponent implements OnDestroy, OnInit {
  private unsubscribe$ = new Subject<void>();
  protected toggleSelect: boolean = false;
  protected menuVisible: boolean = false;
  menuOptions = MENU_OPTIONS;
  currentMenu: string | null = null;
  selectedMenu: string | null = null;

  constructor(
    protected currentStateService: CurrentStateService,
    private router: Router,
    protected keycloakService: KeycloakService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    const storedMenu = this.localStorageService.getItem('currentMenu');
    if (storedMenu && Object.values(this.menuOptions).includes(storedMenu.toString())) {
      this.currentMenu = storedMenu.toString();
      this.currentStateService.setCurrentMenu(storedMenu.toString());
    }

    this.currentStateService.currentMenu$.subscribe((menu: string | null) => {
      this.setCurrentMenu(menu);
    });
  }

  setCurrentMenu(menu: string | null): void {
    this.currentMenu = menu;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  goToMapWithControlPoints(): void {
    this.currentMenu = this.menuOptions.CONTROL_POINT;
    this.localStorageService.setItem('currentMenu', this.menuOptions.CONTROL_POINT);
    this.currentStateService.setCurrentMenu(this.menuOptions.CONTROL_POINT);
    this.router.navigate(['/control-point']);
  }

  goToMapWithEvents(): void {
    this.currentMenu = this.menuOptions.EVENT;
    this.localStorageService.setItem('currentMenu', this.menuOptions.EVENT);
    this.currentStateService.setCurrentMenu(this.menuOptions.EVENT);
    this.router.navigate(['/event']);
  }

  protected openDevicePage() {
    this.currentStateService.setCurrentEvent(null);
    this.currentStateService.setCurrentControlPoint(null);
    this.router.navigate(['/devices']);
    this.localStorageService.setItem('currentMenu', this.menuOptions.DEVICES);
    this.currentStateService.setCurrentMenu(this.menuOptions.DEVICES);
  }

  protected openMonitoringPage() {
    this.currentStateService.setCurrentEvent(null);
    this.currentStateService.setCurrentControlPoint(null);
    this.router.navigate(['/monitoring']);
    this.localStorageService.setItem('currentMenu', this.menuOptions.MONITORING);
    this.currentStateService.setCurrentMenu(this.menuOptions.MONITORING);
  }

  protected openTimelinePage() {
    this.currentStateService.setCurrentEvent(null);
    this.currentStateService.setCurrentControlPoint(null);
    this.router.navigate(['/timeline']);
    this.localStorageService.setItem('currentMenu', this.menuOptions.TIMELINE);
    this.currentStateService.setCurrentMenu(this.menuOptions.TIMELINE);
  }
}